import { $t } from "helpers/translator"

const ConnectYourFirstClinic = {
    steps: [
        {
            target: '#assignClinic',
            title: $t('global.tours.ConnectYourFirstClinic.0.title'),
            content: $t('global.tours.ConnectYourFirstClinic.0.content'),
            clickToContinue: true
        },
        {
            target: '#clinicNumberInput',
            title: $t('global.tours.ConnectYourFirstClinic.1.title'),
            content: $t('global.tours.ConnectYourFirstClinic.1.content'),
            waitForElement: true,
            locale: {
                last: $t('global.tours.ConnectYourFirstClinic.1.confirm')
            }
        }
    ],
    url: '/clinics'
}

export default ConnectYourFirstClinic